import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { LoginFormData } from "@/modules/LoginForm/types";
import { getAuthHeader } from "@/utils/getAuthHeader";

import type {
  AcceptInviteData,
  IMeRestaurantResponse,
  IRestaurantLogin,
} from "./types";

export const authRestaurantApi = {
  async postLogin(userData: LoginFormData) {
    const response = await apiClient.postPublic<IRestaurantLogin>(
      `${API_ENDPOINTS.RESTAURANTS}/auth/login`,
      userData
    );
    return response;
  },

  async postAcceptInvite(token: string, data: AcceptInviteData) {
    const response = await apiClient.postPublic(
      `${API_ENDPOINTS.RESTAURANTS}/auth/accept-invite?token=${token}`,
      data
    );
    return response;
  },

  async checkInviteToken(token: string): Promise<{ email: string }> {
    const response = await apiClient.getPublic<{ email: string }>(
      `${API_ENDPOINTS.RESTAURANTS}/auth/validate-invite-token?token=${token}`
    );
    return response;
  },

  async postLogout(token: string) {
    return await apiClient.post(
      `${API_ENDPOINTS.RESTAURANTS}/auth/logout`,
      undefined,
      getAuthHeader(token)
    );
  },

  async getMe(): Promise<IMeRestaurantResponse> {
    const response = await apiClient.get<IMeRestaurantResponse>(
      `${API_ENDPOINTS.RESTAURANTS}/auth/me`
    );
    return response;
  },
};
